import styles from "../../styles";
import { GameRouteService } from "../../services/GameRouteService";

/**
 * Component for rendering restart confirmation popup
 */
export class AskNameComponent extends HTMLElement {
    /**
     * Called when the element is connected to the DOM
     */
    public connectedCallback(): void {
        this.render();
        this.setupEventListeners();
    }

    /**
     * Called when the element is disconnected from the DOM
     */
    public disconnectedCallback(): void {
        this.removeEventListeners();
    }

    /**
     * Render the component
     */
    private render(): void {
        const content: string = `
            <style>${styles.popups}</style>
            <div class="popup-overlay">
                <div class="popup">
                    <div class="restart-confirmation">
                        <h3>Can you please add a name in the box below?</h3>
                        <p>This will be used for the leaderboards</p>
                        <p id="text" style="display: none;"> Name is already in use! </p>
                        <div class="restart-buttons">
                            <input type="text" id="player-name-input" placeholder="Your name"/>
                            <button id="player-name-submit">Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        `;
        this.innerHTML = content;
    }

    /**
     * Setup event listeners
     */
    private setupEventListeners(): void {
        const submitButton: HTMLElement | null = this.querySelector("#player-name-submit");
        if (submitButton) {
            submitButton.addEventListener("click", this.handleSubmit.bind(this));
        }
    }

    /**
     * Remove event listeners
     */
    private removeEventListeners(): void {
        const submitButton: HTMLElement | null = this.querySelector("#player-name-submit");
        if (submitButton) {
            submitButton.removeEventListener("click", this.handleSubmit.bind(this));
        }
    }

    /**
     * Handle submit button click
     */
    private async handleSubmit(): Promise<void> {
        const inputElement: HTMLInputElement | null = this.querySelector("#player-name-input");

        if (inputElement && inputElement.value.trim() !== "") {
            try {
                const gameRouteService: GameRouteService = new GameRouteService();

                const res: boolean = await gameRouteService.savePlayerName(inputElement.value.trim());

                if (res) {
                    this.remove();
                    localStorage.setItem("playerName", inputElement.value.trim());
                }
                else {
                    inputElement.value = "";
                    const text: HTMLElement | null = this.querySelector("#text");
                    if (text) {
                        text.style.display = "block";
                    }
                }
            }
            catch (error) {
                console.error("Error in handleSubmit:", error);
            }
        }
    }
}
